export default {
	arePaymentsUpToDate: true
};
